import { isDefaultRovoChat } from '@atlassian/conversation-assistant-utils/default-agent';

type ConciergeSelection = {
	agent_id?: string | null;
	agent_name?: string | null;
	agent_named_id?: string | null;
	agent_identity_account_id?: string | null;
};

export type ConciergeSelectedAgentUpdate =
	| {
			type: 'set';
			agent: {
				agent_id: string;
				agent_name: string;
				agent_named_id: string;
				identity_account_id?: string;
				creator_type: '';
			};
	  }
	| { type: 'clear' }
	| { type: 'preserve' };

const normalizeId = (id: string | null | undefined): string | undefined => id?.trim() || undefined;

export const resolveConciergeSelectedAgentUpdate = ({
	agentsOnlyEnabled,
	baseConversationAgentId,
	requestAgentId,
	selection,
}: {
	agentsOnlyEnabled: boolean;
	baseConversationAgentId?: string;
	requestAgentId?: string;
	selection: ConciergeSelection;
}): ConciergeSelectedAgentUpdate => {
	const selectedAgentId = normalizeId(selection.agent_id);
	const baseAgentId = normalizeId(baseConversationAgentId);
	const requestedAgentId = normalizeId(requestAgentId);

	if (agentsOnlyEnabled && selectedAgentId !== undefined && selectedAgentId === baseAgentId) {
		return { type: 'clear' };
	}

	if (selectedAgentId) {
		return {
			type: 'set',
			agent: {
				agent_id: selectedAgentId,
				agent_name: selection.agent_name ?? '',
				agent_named_id: selection.agent_named_id ?? '',
				identity_account_id: selection.agent_identity_account_id ?? undefined,
				creator_type: '',
			},
		};
	}

	const isUserMentionTurn =
		requestedAgentId !== undefined &&
		!isDefaultRovoChat({ agentId: requestedAgentId }) &&
		(!agentsOnlyEnabled || requestedAgentId !== baseAgentId);

	return isUserMentionTurn ? { type: 'preserve' } : { type: 'clear' };
};
